import { Component, inject } from '@angular/core';
import { AppComponent } from '../../app.component';

@Component({
    selector: 'mmoga-footer',
    imports: [],
    templateUrl: './footer.component.html',
    standalone: true,
    styleUrl: './footer.component.scss'
})
export class FooterComponent {
    private appComponent = inject(AppComponent);


    version: string;

    constructor() {
        this.version = this.appComponent.appVersion;
    }
}
